// import { useState } from 'react';
import Navbar from "../Shared/Navbar.jsx";
import HeroSection from './HeroSection.jsx';
import AboutTheChange from './AboutTheChange.jsx';
import WhatWeDo from './WhatWeDo.jsx';
import ServicesShowcase from './ServicesShowcase.jsx';
// import ContactSection from './ContactSection.jsx';
// import AssistanceBar from './AssistanceBar.jsx';
// import HowItWorks from './HowItWorks.jsx';
// import Services from './Services.jsx';
// import TrustedBy from '../Shared/TrustedBy.jsx';
// import LiveChat from './liveChat.jsx';
import Footer from '../Shared/Footer.jsx';

const Home = () => {
  // const [isOpen, setIsOpen] = useState(false);
  return (
    <div>
      <Navbar />
      <main>
        <HeroSection />
        <ServicesShowcase />
        <AboutTheChange />
        <WhatWeDo />
        {/* <ContactSection /> */}
        {/* <AssistanceBar setIsOpen={setIsOpen} /> */}
        {/* <HowItWorks /> */}
        {/* <Services /> */}
        {/* <TrustedBy /> */}
      </main>
      {/* <LiveChat isOpen={isOpen} setIsOpen={setIsOpen} /> */}
      <Footer />
    </div>
  );
};

export default Home;